export class SelectedProductActivity {
    activityName!: string
    activityId!: string
}
  